module.exports = __webpack_public_path__ + "img/中快传媒.0ed7064a.png";